import React, { useEffect, useRef, useState } from 'react';
import Modal from 'modal-enhanced-react-native-web';
import { useDispatch, useSelector } from 'react-redux';
import { GroupMessageProps, GroupPlayerProps, GroupProps } from '../../../store/types/soc_svc';
import { ActivityIndicator, FlatList, View, ScrollView } from 'react-native';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { social_getGroupById, social_saveMessage } from '../../../store/actionsv1/social';
import Colors from '../../../constants/Colorsv2';
import moment from 'moment';
import RichTextInput from './RichTextComponents/RichTextInput';
import { message_getEmptyMessage, message_getUniqueDates } from '../helpers/messages';
import { socket_joinChat, socket_leaveChat } from '../../../store/actionsv1/socket';
import { Icon } from 'react-native-elements';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import MessageCard from './MessageCard';
import { player_getBulkPlayers } from '../../../store/actionsv1/player';
import ChatCard from './ChatCard';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import RTIToolbar from './RichTextComponents/RTIToolbar';
import GroupChatHeader from './GroupChatHeader';


type GroupChatModalProps = {
    group_id?:string,
    expanded?:boolean,
    onCloseExpand: () => void,
    show_last_message?:boolean,
    onLastMessageUpdate: (message:string) => void;
    top?: number,
    bottom?: number,
    left?: number,
    right?:number,
    expanded_width:number
}

const GroupChatModal = ({ group_id, expanded, show_last_message, top, bottom, left, right, expanded_width, onLastMessageUpdate, onCloseExpand }:GroupChatModalProps) => {
    const [ last_message, setLastMessage ] = useState<string | undefined>(undefined);
    const [ expanded_override, setExpandedOverride ] = useState(false);

    const dispatch = useDispatch();
    const player:PublicPlayerProps|undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const group:GroupProps = useSelector((state:any) => state.social.group, (left, right) => left?.group_id == right?.group_id)
    const group_messages:GroupMessageProps[] = useSelector((state:any) => state.social.group_messages.filter((gm:GroupMessageProps) => gm.group_id == group_id), (left, right) => left.length == right.length)
    const group_players:GroupPlayerProps[] = useSelector((state:any) => state.social.group_players.filter((gp:GroupPlayerProps) => gp.group_id == group_id), (left, right) => left.length == right.length)
    const unique_players = [ ...new Set(group_messages.map(gm => gm.player_id)) ]
    useEffect(() => {
        if(!group_id){ dispatch(socket_leaveChat()); return }
        dispatch(social_getGroupById(group_id))
        dispatch(socket_joinChat(group_id))
    },[group_id])


    useEffect(() => {
        if(unique_players.length === 0 || (!expanded && !expanded_override)){ return }
        dispatch(player_getBulkPlayers(unique_players))
    }, [unique_players, expanded])

    useEffect(() => {
        if(!last_message){ return }
        if(onLastMessageUpdate){ onLastMessageUpdate(last_message) }
    },[last_message])


    useEffect(() => {
        if(group_messages.length === 0){ return }
        if(last_message){ return }
        let last = group_messages.sort((a,b) => moment(a.create_datetime).unix() - moment(b.create_datetime).unix())[group_messages.length - 1]
        setLastMessage(last.message)
        setTimeout(() => {
            setLastMessage(undefined)
        }, 5000);
    },[group_messages.length])

    const handleCloseExpand = () => {
        setExpandedOverride(false);
        onCloseExpand();
    }
    if(!group){
        return <></>
    }
    if((expanded_override || expanded) && group && player){
        return (
            <GroupChatModalExpanded onClose={() => handleCloseExpand()} player={player} width={expanded_width} group={group} group_messages={group_messages} group_players={group_players}/>
        )
    }
    let visible_message = last_message
    if(visible_message && visible_message.length > 50){
        visible_message = `${visible_message.slice(0, 50)}...`
    }
    return (
        <View style={{position:'absolute', top, right, left, bottom}}>
            {last_message && show_last_message ?
            <TouchableOpacity style={{ borderRadius:20, flexDirection:'row', alignItems:'center', padding:10, backgroundColor: Colors.brand.electric, shadowColor: "rgba(221, 221, 221, 0.6)", shadowOffset: { width: 0, height: 10 }, shadowRadius: 10, shadowOpacity: 1 }}
            onPress={() => setExpandedOverride(true)}>
                <Icon name='message-circle' type='feather' size={14} color={Colors.shades.white} />
                <Text style={{ marginLeft:5 }} size={12} color={Colors.shades.white}>{visible_message}</Text>
            </TouchableOpacity>
            :
            <></>
            }
        </View>
    )
}

/*

*/
export default GroupChatModal



type GroupChatModalExpandedProps = {
    width: number,
    group:GroupProps,
    player:PublicPlayerProps,
    onClose: () => void,
    group_messages:GroupMessageProps[],
    group_players:GroupPlayerProps[]
}
const GroupChatModalExpanded = ({ width, player, group, group_messages, group_players, onClose }:GroupChatModalExpandedProps) => {
    const [ clear, setClear ] = useState(false);
    const [ toolbar_visible, setToolbarVisible ] = useState(false);
    const [ draft_message, setDraftMessage ] = useState(message_getEmptyMessage())
    const [ init_loaded, setInitLoded ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ uniqueDates, setUniqueDates ] = useState([moment().format('MMM DD')])

    const dispatch = useDispatch();
    const insets = useSafeAreaInsets();

    useEffect(() => {
        if(group_messages.length > 0){
            setUniqueDates(message_getUniqueDates(group_messages))
        }
    },[group_messages.length])

    useEffect(() => {
        if(!group) { setInitLoded(false); return; }
        setTimeout(() => {
            setInitLoded(true)
        }, 1000);
    },[group])


    const handleSendMessage = async() => {
        if(loading || !player || !group){ return }
        if(!draft_message.message || draft_message.message === '' || !draft_message.formatted_body){ return alert('Message cannot be blank') }
        setLoading(true)
        await dispatch(social_saveMessage({ ...draft_message, group_id:group.group_id, player_id:player.player_id }))
        setClear(true)
        setDraftMessage(message_getEmptyMessage())
        setLoading(false)
    }


    const handleImageUpload = async(image:any) => {
        if(!group || !player){ return }
        let message = message_getEmptyMessage()
        setLoading(true)
        await dispatch(social_saveMessage({ ...message, message_images:[image], group_id:group.group_id, player_id:player.player_id }))
        setLoading(false)
    }

    const handleVideoUpload = async(video:any) => {
        if(!group || !player){ return }
        let message = message_getEmptyMessage()
        setLoading(true)
        await dispatch(social_saveMessage({ ...message, message_videos:[video], group_id:group.group_id, player_id:player.player_id }))
        setLoading(false)
    }

    const handleOrderUpload = async(orders:string[]) => {
        if(!group || !player){ return }
        let message = message_getEmptyMessage()
        setLoading(true)
        await dispatch(social_saveMessage({ ...message, message_orders:orders, group_id:group.group_id, player_id:player.player_id }))
        setLoading(false)
    }

    const handleUrlUpload = async(url:string, url_preview:any) => {
        if(!group || !player){ return }
        let message = message_getEmptyMessage()
        setLoading(true)
        await dispatch(social_saveMessage({ ...message, message_urls:[url], url_metadata:[url_preview], group_id:group.group_id, player_id:player.player_id }))
        setLoading(false)
    }

    const scrollView = useRef(null)

    const renderMessages = (data: { item:GroupMessageProps, index:number }) => {
        if(!data.item.group_message_id){ return (<></>) }
        let date = uniqueDates.find(d => d.message_index == data.index)
        let me = data.item.player_id == player?.player_id ? true: false
        return (
            <View style={{ flex:1 }}>
                {date?
                <View style={{ borderBottomWidth:1, borderBottomColor:Colors.shades.shade100, marginBottom:10 }}>
                    <Text color={Colors.brand.midnight} size={14} weight='bold' textAlign='left' style={{ marginBottom:6 }}>{date.date}</Text>
                </View>
                :<></>}
                <ChatCard groupMessage={data.item} me_ind={me}/>
            </View>
        )
    }

    return (
        <Modal propagateSwipe={true} isVisible={true} deviceWidth={width} style={{ flex:1, margin:0 }}
            animationIn='slideInUp' animationOut='slideOutDown' animationInTiming={500} onSwipeComplete={() => console.log('complete')} onBackdropPress={() => console.log('close')}>
                <View style={{ ...localStyles.modalStyle, width, paddingTop:insets.top, paddingBottom:insets.bottom }} >
                    <GroupChatHeader players={[]} group={group} onClose={() => onClose()}/>
                    <ScrollView 
                        style={{ flex:1, backgroundColor:Colors.shades.white, padding:10 }} 
                        ref={scrollView} 
                        keyboardShouldPersistTaps='handled'
                        onContentSizeChange={(contentWidth, contentHeight)=>{        
                            scrollView.current.scrollToEnd({animated: true});
                        }}
                        >
                        {!init_loaded ?
                        <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                            <ActivityIndicator size='large' color={Colors.brand.midnight}/>
                        </View>
                        : group_messages.length > 0 ?
                            <FlatList data={group_messages.sort((a,b) => moment(a.create_datetime).unix() - moment(b.create_datetime).unix())} renderItem={renderMessages} keyExtractor={(item, index) => item.group_message_id.toString()} extraData={[uniqueDates]}/>
                        :
                        <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                            <Text size={16} color={Colors.brand.midnight} weight='regular' textAlign='center'>Start The Conversation!</Text>
                        </View>
                        }
                        </ScrollView>
                    {toolbar_visible ? 
                    <RTIToolbar
                        selected_orders={draft_message.message_orders}
                        onTagOrders={(orders) => handleOrderUpload(orders)}
                        onImageUpload={(image) => handleImageUpload(image)} 
                        onVideoUpload={(video) => handleVideoUpload(video)} 
                        onLinkCreate={(link, link_preview) => handleUrlUpload(link, link_preview)}
                        onToolSelect={(tool) => console.log(tool)}
                        />
                :<></>}
                    <View style={{ padding:20, backgroundColor:Colors.brand.midnight }}>
                        <View style={{ flexDirection:'row', alignItems:'center' }}>
                            <TouchableOpacity style={{ height:42, width:42, justifyContent:'center', alignItems:'center', marginRight:5 }} onPress={() => setToolbarVisible(true)}>
                                <Icon name='plus' type='feather' color={Colors.shades.white} size={20} />
                            </TouchableOpacity>
                            <View style={{ flex:1, backgroundColor:Colors.shades.shade100, borderRadius:20, padding:10 }}>
                                <RichTextInput clear={clear} onClear={() => setClear(false)} placeholder='Start typing here' onUpdate={(formatted_body, message) => setDraftMessage({ ...draft_message, formatted_body, message })}/>
                            </View>
                            <TouchableOpacity style={{ height:42, width:42, backgroundColor:Colors.brand.midnight, borderRadius:100, justifyContent:'center', alignItems:'center', marginLeft:10 }} onPress={() => handleSendMessage()}>
                                <Icon name='send' type='feather' size={18} color={Colors.shades.white} />
                            </TouchableOpacity>
                        </View>
                    </View>
                </View>
            </Modal>
            
    )
}

const localStyles = {
    modalStyle: { flex:1, backgroundColor: Colors.brand.midnight },
}
